import { render, staticRenderFns } from "./classical-announcement.vue?vue&type=template&id=7974560a"
import script from "./classical-announcement.vue?vue&type=script&lang=js"
export * from "./classical-announcement.vue?vue&type=script&lang=js"
import style0 from "./classical-announcement.vue?vue&type=style&index=0&id=7974560a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports